export default __webpack_public_path__ + "static/media/tutorials-active-icon.2a833493.svg";